import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
  Row,
  Col,
  Button,
  FormGroup,
  Label,
  Input,
  Modal,
  ModalBody,
  ModalHeader,
  ModalFooter,
} from "reactstrap";
import { Tag } from "react-feather";

import { fetchVideos } from "../VideoActions";
import { actions, operations } from "../../../Shared/modules/videoList";
import VideoList from "./VideoList";
import Loader from "../../../Shared/Loader";
import endpoints from "../../../Shared/modules/api/endpoints";
import Cookies from "js-cookie";

const multiPublishVideos = (payload) =>
  new Promise((resolve, reject) =>
    $.ajax({
      method: "put",
      url: endpoints.multiPublishVideos,
      data: payload,
      success(data, statusText, { status }) {
        console.log(statusText);
        resolve(status);
      },
      error(xhr) {
        console.log("error", xhr);
        reject(xhr);
      },
    })
  );

const SuccessMessage = ({ tabType, isPublish }) => (
  <div className="SuccessMessage">
    {isPublish ? <h1>&#127881;</h1> : <h1>&#128226;</h1>}
    <h6>
      {isPublish ? (
        <b>
          Your video(s) have been published to the{" "}
          <span>{tabType === "fan" ? "shopper" : tabType}</span> tab
        </b>
      ) : (
        <b>Your video(s) have been unpublished</b>
      )}
    </h6>
  </div>
);

const SelectTab = ({
  checkedAllVideos,
  totalVideoCount,
  selectedVideos,
  tabType,
  handleTabType,
}) => (
  <div className="select-tab-multi-publish align-self-center text-align-center">
    <h5>
      <b>
        You selected{" "}
        <span>
          {checkedAllVideos
            ? totalVideoCount
            : selectedVideos && selectedVideos.length}
        </span>{" "}
        videos
      </b>
    </h5>
    <br />
    <div className="SelectTab-Image">
      <img
        src={require(`@src/assets/images/shopify-logo.svg`).default}
        alt=""
        width={140}
        height="auto"
      />
    </div>
    <br />
    <h5>
      <b>Where would you like them?</b>
    </h5>
    <br />
    <div className="SelectTab-Actions">
      <Button
        color={tabType === "fan" ? "primary" : "secondary"}
        onClick={handleTabType("fan")}
        size="md"
        className="mr-1"
      >
        <i className="fa-solid fa-user-tag" style={{ fontSize: "16px" }}></i>{" "}
        Shopper video tab
      </Button>

      <Button
        color={tabType === "brand" ? "primary" : "secondary"}
        onClick={handleTabType("brand")}
        size="md"
      >
        <Tag size={"18"} /> Brand video tab
      </Button>
    </div>
  </div>
);

const VideoSubtitle = ({
  selectedVideos,
  checkedAllVideos,
  handleToggleSelectAll,
}) => (
  <>
    <Row className="p-2">
      <Col lg={"8"}>
        <span>
          <b>{selectedVideos?.length}</b> selected videos
        </span>
      </Col>
      <Col lg={"4"} className="select-all-videos-app primary-checkbox">
        <FormGroup check>
          <Label check>Select all videos </Label>
        </FormGroup>{" "}
        <FormGroup check>
          <Label check></Label>
          <Input
            type="checkbox"
            checked={checkedAllVideos}
            onChange={handleToggleSelectAll}
            name="selectAllVideos"
            color="primary"
          />{" "}
        </FormGroup>
      </Col>
    </Row>
  </>
);

const getFavoriteState = (params) => {
  if (
    params &&
    params.filters &&
    params.filters.note &&
    params.filters.note.length
  ) {
    return params.filters.note.includes("favorite");
  }
  return false;
};

const MultiPublish = ({
  open,
  onClose,
  videos,
  videoProducts,
  totalVideoCount,
  totalPages,
  params,
  fetchVideoList,
  doVideoListSuccess,
  doFetchVideos,
  videoList,
  pathname,
  handleUnpublishClick,
}) => {
  const [step, setStep] = useState(1);
  const [page, setPage] = useState(1);
  const [tabType, setTabType] = useState("fan");
  const [selectedVideos, setSelectedVideos] = useState([]);
  const [checkedFavorite, setCheckedFavorite] = useState(
    getFavoriteState(params)
  );
  const [checkedAllVideos, setCheckedAllVideos] = useState(false);
  const [loadingPublish, setLoadingPublish] = useState(false);
  const { body, status } = videoList || {};
  const hasMore = page < totalPages;
  const loading = status === "loading";
  const isPublish = pathname === "videos";

  useEffect(() => {
    doVideoListSuccess({ data: videos });
  }, [videos]);

  useEffect(() => {
    if (checkedAllVideos) {
      setSelectedVideos(body ? body.map(({ video }) => video._id) : []);
    }
  }, [body]);

  const handleAddVideosToList = () => {
    const nextPage = page + 1;
    setPage(nextPage);

    fetchVideoList(
      {
        ...params,
        brand_id: Cookies.get("bId"),
        user_id: Cookies.get("uId"),
        page: nextPage,
      },
      true
    );
  };

  const handleTabType = (tab) => () => {
    setTabType(tab);
  };

  const handleToggleFavorite = () => {
    setCheckedFavorite((prevValue) => !prevValue);
    // TODO: WIP
    /* const filters = { ...params.filters };
    if (!checkedFavorite) {
      filters.note = [
        ...filters.note,
        'favorite',
      ];
    } else {
      filters.note = [
        ...filters.note,
      ];
    } */
    /* fetchVideoList({
      ...params,
      filters,
      page: 1,
    }, false); */
  };

  const handleToggleSelectAll = ({ target }) => {
    const { checked } = target;
    if (checked) {
      setSelectedVideos(body ? body.map(({ video }) => video._id) : []);
    } else {
      setSelectedVideos([]);
    }
    setCheckedAllVideos(checked);
  };

  const handlePublish = () => {
    setLoadingPublish(true);
    setStep(3);
    const payload = {
      published_on_platform: "Shopify",
      shared_on_tab: tabType,
      is_publish: true,
      is_widget: true,
      ...params,
    };
    if (pathname === "videos") {
      payload.is_videos_section = true;
    } else {
      payload.is_widget_section = true;
    }
    if (checkedAllVideos) {
      payload.checked_all_videos = true;
    } else {
      payload.selected_videos = selectedVideos;
    }
    payload.brand_id = Cookies.get("bId");
    payload.user_id = Cookies.get("uId");

    multiPublishVideos(payload).then(() => {
      setLoadingPublish(false);
      //doFetchVideos(params);
    });
  };

  const handleUnpublish = () => {
    setLoadingPublish(true);
    setStep(3);
    const payload = { ...params, is_widget: true, is_unpublish: true };
    if (pathname === "videos") {
      payload.is_videos_section = true;
    } else {
      payload.is_widget_section = true;
    }
    if (checkedAllVideos) {
      payload.checked_all_videos = true;
    } else {
      payload.selected_videos = selectedVideos;
    }
    payload.brand_id = Cookies.get("bId");
    payload.user_id = Cookies.get("uId");

    multiPublishVideos(payload).then(() => {
      setLoadingPublish(false);
    });

    handleUnpublishClick(); // Mixpanel tracking for Unpublish button
  };

  const handleCheckListItem = (value) => () => {
    const index = selectedVideos.indexOf(value);
    const newSelectedVideos = [...selectedVideos];

    if (index === -1) {
      newSelectedVideos.push(value);
    } else {
      newSelectedVideos.splice(index, 1);
      setCheckedAllVideos(false);
    }

    setSelectedVideos(newSelectedVideos);
  };

  const handleClose = () => {
    onClose();
    doFetchVideos(params);
    setTimeout(() => {
      doVideoListSuccess({ data: videos });
      setCheckedFavorite(false);
      setCheckedAllVideos(false);
      setSelectedVideos([]);
      setStep(1);
      setPage(1);
    }, 500);
  };

  const handleApprove = () => {
    if (loadingPublish) {
      return false;
    }

    switch (step) {
      case 1:
        return () => setStep(2);
      case 2:
        return isPublish ? handlePublish : handleUnpublish;
      case 3:
        return handleClose;
      default:
        return () => {};
    }
  };

  const filterUnpublishedVideos = ({ video }) =>
    video &&
    video.published_on_platforms &&
    Array.isArray(video.published_on_platforms) &&
    !video.published_on_platforms.includes("Shopify");

  const filterPublishedVideos = ({ video }) =>
    video &&
    video.published_on_platforms &&
    Array.isArray(video.published_on_platforms) &&
    video.published_on_platforms.includes("Shopify");

  const getFilteredVideos = (initialVideos) =>
    initialVideos && initialVideos.length > 0
      ? initialVideos.filter(
          isPublish ? filterUnpublishedVideos : filterPublishedVideos
        )
      : [];

  return (
    <Modal className="MultiPublish" isOpen={open} size="lg">
      <ModalHeader toggle={loadingPublish ? () => {} : handleClose}>
        {step === 3 ? "" : isPublish ? "Publish to app" : "Unpublish from app"}
      </ModalHeader>
      <ModalBody>
        {step === 1 ? (
          <VideoSubtitle
            totalVideoCount={totalVideoCount}
            selectedVideos={selectedVideos}
            checkedFavorite={checkedFavorite}
            checkedAllVideos={checkedAllVideos}
            handleToggleFavorite={handleToggleFavorite}
            handleToggleSelectAll={handleToggleSelectAll}
          />
        ) : null}

        {step === 1 && (
          <VideoList
            videos={getFilteredVideos(body)}
            selectedVideos={selectedVideos}
            onCheck={handleCheckListItem}
            videoProducts={videoProducts}
            hasMore={hasMore}
            loading={loading}
            getMore={handleAddVideosToList}
            isPublish={isPublish}
          />
        )}
        {step === 2 && isPublish && (
          <SelectTab
            checkedAllVideos={checkedAllVideos}
            totalVideoCount={totalVideoCount}
            selectedVideos={selectedVideos}
            tabType={tabType}
            handleTabType={handleTabType}
          />
        )}
        {step === 2 && !isPublish && (
          <div className="ActionConfirmation text-center">
            <h6>
              <b>
                You selected{" "}
                <span>
                  {checkedAllVideos
                    ? totalVideoCount
                    : selectedVideos && selectedVideos.length}
                </span>{" "}
                videos
              </b>
            </h6>
            <br />
            <div className="SelectTab-Image">
              <img
                src={require(`@src/assets/images/shopify-logo.svg`).default}
                alt=""
                width={180}
                height="auto"
              />
            </div>
            <br />
            <h6>
              <b>Are you sure you want to unpublish?</b>
            </h6>
          </div>
        )}
        {step === 3 &&
          (loadingPublish ? (
            <div className="MultiPublish-Loader">
              <Loader />
            </div>
          ) : (
            <SuccessMessage tabType={tabType} isPublish={isPublish} />
          ))}
      </ModalBody>
      <ModalFooter>
        <Button
          color={"primary"}
          onClick={handleApprove()}
          size="lg"
          disabled={selectedVideos?.length === 0 || loadingPublish}
        >
          {step === 3 ? "Ok" : isPublish ? "Publish" : "Unpublish"}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

MultiPublish.defaultProps = {};

MultiPublish.propTypes = {};

const mapStateToProps = ({ videoList }) => ({
  videoList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      fetchVideoList: operations.fetchVideoList,
      doVideoListSuccess: actions.doVideoListSuccess,
      doFetchVideos: fetchVideos,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(MultiPublish);
